import {Typography} from 'antd';
import {ReactNode} from 'react';
import styles from './index.module.scss';

export interface IPageTitleProps {
  children: ReactNode | ReactNode[];
}

const PageTitle = ({children}: IPageTitleProps) => (
  <div className={styles.pageTitleWrap}>
    <Typography.Title level={3}>{children}</Typography.Title>
  </div>
);
export default PageTitle;
